<template>
  <v-list-item class="queue-agent">
    <status-avatar
      class="mr-4"
      :user="avatarUser(agent.exten)"
      avatar-size="36px"
      badge-size="12px"
    />
    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        {{ agent.name }} <small>x{{ agent.exten }}</small>
      </v-list-item-title>
      <v-list-item-subtitle
        class="caption"
        v-if="agent.paused && !!agent.pausedReason"
      >
        {{ agent.pausedReason }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon :color="iconActiveColor(agent.ignorebusy)" small v-on="on">
              mdi-information</v-icon
            >
          </template>
          <span>{{ $t("queues.agent.ignoreBusy") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon :color="iconActiveColor(agent.ringinuse)" small v-on="on">
              mdi-check-underline-circle</v-icon
            >
          </template>
          <span>{{ $t("queues.agent.ringInUse") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on"
              ><v-icon small> mdi-check-circle</v-icon
              >{{ agent.answered }}</span
            >
          </template>
          <span
            >{{ $t("queues.agent.callsTaken") }}: {{ agent.answered }}.</span
          >
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on"
              ><v-icon small> mdi-timer-sand-full</v-icon
              >{{ agent.holdtime | formatTime }}</span
            >
          </template>
          <span
            >{{ $t("queues.agent.respDelay") }}:
            {{ agent.holdtime | formatTime }}.</span
          >
        </v-tooltip>
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        <template v-for="(call, idx) in agent.calls">
          <AgentCalls
            :agent-exten="agent.exten"
            :agent-subid="agent.subscriberId"
            :call="call"
            :key="idx"
          />
        </template>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            class="mt-2"
            @click="promptPause"
            v-on="on"
            :color="agentIconColor(agent)"
          >
            mdi-{{ agentIcon(agent) }}
          </v-icon>
        </template>
        <span>{{ pauseTooltip }}</span>
      </v-tooltip>
    </v-list-item-action>

    <PauseConfirm
      :show="pausePrompt"
      :title="agent.paused ? 'unpauseAgent' : 'pauseAgent'"
      :title-icon="agent.paused ? 'play' : 'pause'"
      :title-icon-color="agent.paused ? 'green' : 'orange'"
      :agents="[agent]"
      @set-pause="pauseAgent"
      @cancel="pausePrompt = false"
    />
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex'
import AgentCalls from './agent_calls'
import PauseConfirm from './pause_confirm'
import * as RMQClient from '@/rmqclient'
import StatusAvatar from '@/components/buddies/status_avatar'

export default {
  name: 'queue-agent',
  data () {
    return {
      pausePrompt: false
    }
  },
  props: {
    agent: {
      type: Object,
      required: true
    },
    queueName: {
      type: String,
      required: true
    }
  },
  components: { AgentCalls, PauseConfirm, StatusAvatar },
  computed: {
    ...mapGetters({
      canSelfPause: 'permissions/canQSelfPause',
      currentUserExten: 'settings/currentUserExten',
      canAgentPause: 'permissions/canQAgentPause',
      users: 'users/listAll',
      buddies: 'users/buddies'
    }),
    canPause: function () {
      return (
        this.canAgentPause(this.agent.subscriberId) ||
        (this.canSelfPause && this.agent.exten === this.currentUserExten)
      )
    },
    pauseTooltip: function () {
      if (this.canPause) {
        return this.$t(
          'queues.tooltip.' + (this.agent.paused ? 'unpause' : 'pause')
        )
      }
      return this.$t('queues.tooltip.pauseNoPerm')
    }
  },
  methods: {
    iconActiveColor: function (active) {
      return active ? 'blue-grey darken-3' : 'blue-grey lighten-4'
    },
    agentIcon: function (agent) {
      if (agent.paused) {
        return 'play'
      } else {
        return 'pause'
      }
    },
    agentIconColor: function (agent) {
      if (agent.paused) {
        return 'green'
      } else {
        return 'amber'
      }
    },
    promptPause: function () {
      if (!this.canPause) {
        return
      }
      this.pausePrompt = true
    },
    pauseAgent: function (code) {
      const action = {
        action: 'QueuePause',
        interface: this.agent.interface,
        paused: this.agent.paused ? 0 : 1,
        queue: this.queueName,
        reason: code
      }
      RMQClient.sendCmd(action)
      this.pausePrompt = false
    },
    avatarUser (extension) {
      const buddyUser = this.buddies.find((user) => user.exten === extension)
      if (buddyUser) {
        return buddyUser
      }
      return this.users.find((user) => user.exten === extension)
    }
  }
}
</script>

<style>
.queue-agent .v-list__tile {
  padding: 0 !important;
}
.queue-agent .v-list__tile {
  height: 60px !important;
}
.v-list {
  padding-top: 0;
}
</style>
